/**
 * hh-cart-upsell.js
 *
 * Delegated click handler for the "Complete the set" cart drawer upsell.
 *
 * Loaded once from theme.liquid (inside the cart_type == 'drawer' guard),
 * guarded by window.__hhCartUpsellInit so it is idempotent even if the script
 * tag were somehow re-executed.
 *
 * On click of [data-hh-cart-upsell-add]:
 *   1. Adds the bundle variant (qty 1) via /cart/add.js
 *   2. Removes the standalone component line via /cart/change.js (qty → 0)
 *      /cart/change.js accepts the line `key` as `id` and returns sections HTML
 *   3. Re-renders the cart drawer with the response via cart-drawer's renderContents()
 */

(function () {
  if (window.__hhCartUpsellInit) return;
  window.__hhCartUpsellInit = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hh-cart-upsell-add]');
    if (!btn) return;

    var bundleVariant = btn.dataset.bundleVariant;
    var removeKey = btn.dataset.removeKey;
    if (!bundleVariant || !removeKey) return;

    // Guard against double-click
    if (btn.disabled) return;
    btn.disabled = true;

    var originalText = btn.textContent;
    btn.textContent = 'Adding…';

    Promise.resolve()
      .then(function () {
        // Step 1: add the bundle variant
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(bundleVariant), quantity: 1 }] }),
        });
      })
      .then(function (addRes) {
        if (!addRes.ok) {
          throw new Error('cart/add failed: ' + addRes.status);
        }
        // Step 2: remove the standalone component (qty → 0), request section re-render
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: removeKey,
            quantity: 0,
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname,
          }),
        });
      })
      .then(function (changeRes) {
        if (!changeRes.ok) {
          throw new Error('cart/change failed: ' + changeRes.status);
        }
        return changeRes.json();
      })
      .then(function (state) {
        // Step 3: re-render the drawer
        var cartDrawerEl = document.querySelector('cart-drawer');
        if (cartDrawerEl && typeof cartDrawerEl.renderContents === 'function') {
          cartDrawerEl.renderContents(state);
          // Announce the change like every other HH cart path (see hhRefreshCart in
          // hh-product.js). Without it the gift engine in hh-shipping-bar.js never ran
          // after a swap, so a set that qualified the cart for a free gift got none.
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hh-cart-upsell', cartData: state });
          }
        } else {
          // Fallback: dispatch a generic cart-updated event Dawn listens to
          document.dispatchEvent(new CustomEvent('shopify:cart:updated', { bubbles: true }));
        }
      })
      .catch(function (err) {
        console.error('[hh-cart-upsell] swap failed:', err);
        // Re-enable on error so the customer can retry
        btn.disabled = false;
        btn.textContent = originalText;
      });
  });
})();
